"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.demonstrations", [
    "nucont.shared",
    "nucont.accounting.company.showtime"
]);
require("./demonstrations.templates");
require("./demonstrations.routes");
require("./financial/financial-demonstrations.routes");
require("./financial/dre/financial-dre.routes");
require("./accounting/accounting-demonstrations.routes");
require("./accounting/dre/accounting-dre.routes");
require("./accounting/balance/accounting-balance.routes");
require("./accounting/balance-sheet/accounting-balance-sheet.routes");
